import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface AvantDefaultIconProps {
  color?: Color;
}

const AvantDefaultIcon: React.FC<AvantDefaultIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_44968)">
      <path
        d="M11.0801 21.36C10.4501 21.36 8.84013 21.44 8.34013 21.51C7.84013 21.58 6.67007 21.89 6.53007 22.23C6.39007 22.57 6.42013 23.35 6.59013 23.48C7.4432 23.5679 8.30415 23.541 9.15007 23.4C9.85798 22.8403 10.5263 22.2321 11.1501 21.58C11.2301 21.49 11.2501 21.36 11.0801 21.36Z"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M21.86 26.97C21.9272 28.1469 21.5887 29.3112 20.901 30.2686C20.2132 31.2259 19.2179 31.9184 18.0812 32.2303C16.9444 32.5422 15.7351 32.4547 14.655 31.9824C13.575 31.5101 12.6896 30.6816 12.1468 29.6352C11.6041 28.5888 11.4366 27.3879 11.6726 26.233C11.9086 25.078 12.5336 24.039 13.4433 23.2894C14.3531 22.5398 15.4924 22.1249 16.6711 22.1141C17.8499 22.1033 18.9967 22.4972 19.92 23.23"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M25.3101 18.46C25.3101 18.46 37.1401 17.87 41.8301 17.78L65.15 17.3"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M42.1899 12.26L40.6799 17.81"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M51.5801 12.57L54.8401 17.51"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M65.13 28.94C66.31 28.81 69.45 28.48 71.02 28.14C72.32 27.85 72.4 24.48 72.4 24.48L71.51 22.57C71.51 22.57 71.51 21.72 71.42 20.65C71.5177 20.1175 71.491 19.5696 71.3418 19.0492C71.1926 18.5287 70.925 18.0498 70.56 17.65C70.56 17.65 63.91 12.96 63.56 12.86C62.4932 12.5871 61.4114 12.3768 60.32 12.23C44.22 10.47 34.71 12.04 33.32 12.49C29.9356 13.9917 26.649 15.7051 23.48 17.62C19.34 17.51 11.4201 18.95 9.70005 19.4C7.89384 19.8537 6.19478 20.6591 4.70005 21.77C3.32005 22.86 3.2 25.94 3.4 27.66C3.6 29.38 4.83004 29.46 5.56004 29.57C6.29004 29.68 9.66001 29.98 9.66001 29.98"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M50.32 29.55L23.48 29.95" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M71.2698 18.8H67.8698C67.8328 18.7974 67.7959 18.8058 67.7636 18.824C67.7313 18.8422 67.7049 18.8694 67.6879 18.9024C67.6709 18.9354 67.6639 18.9726 67.6678 19.0095C67.6717 19.0463 67.6864 19.0813 67.7099 19.11C67.9007 19.3976 68.1112 19.6716 68.3399 19.93C68.5899 20.19 68.9898 20.74 69.4998 20.77C70.0098 20.8 71.4399 20.77 71.4399 20.77"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M63.4699 26.97C63.533 28.142 63.1921 29.3001 62.5045 30.2512C61.8168 31.2023 60.8239 31.8889 59.6913 32.1963C58.5586 32.5038 57.3547 32.4136 56.2805 31.9407C55.2063 31.4679 54.3268 30.641 53.7885 29.598C53.2503 28.5551 53.086 27.3591 53.323 26.2096C53.56 25.0601 54.1839 24.0267 55.0908 23.2816C55.9977 22.5366 57.1326 22.1251 58.3062 22.1157C59.4799 22.1063 60.6212 22.4996 61.5399 23.23"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_44968">
        <rect width="70" height="22" fill="white" transform="translate(3 11)" />
      </clipPath>
    </defs>
  </svg>
);

export default AvantDefaultIcon;
